import type * as lazyIndex from './lazyIndex';
import { LazyImport, LazyModule } from 'owa-bundling-light';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "RibbonHelp"*/ './lazyIndex'),
    {
        name: 'RibbonHelp',
    }
);

export const lazyGetSLRHelpTab: LazyImport<typeof lazyIndex.getSLRHelpTab, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.getSLRHelpTab);
export const lazyGetMLRHelpTab: LazyImport<typeof lazyIndex.getMLRHelpTab, typeof lazyModule> =
    new LazyImport(lazyModule, m => m.getMLRHelpTab);
export const lazyGetSLRHelpTabGroups: LazyImport<
    typeof lazyIndex.getSLRHelpTabGroups,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getSLRHelpTabGroups);
export const lazyGetMLRHelpTabGroups: LazyImport<
    typeof lazyIndex.getMLRHelpTabGroups,
    typeof lazyModule
> = new LazyImport(lazyModule, m => m.getMLRHelpTabGroups);
